import { render, staticRenderFns } from "./declarationText.vue?vue&type=template&id=54bbf032&scoped=true&"
import script from "./declarationText.vue?vue&type=script&lang=js&"
export * from "./declarationText.vue?vue&type=script&lang=js&"
import style0 from "./declarationText.vue?vue&type=style&index=0&id=54bbf032&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bbf032",
  null
  
)

export default component.exports